import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import EncodeUtils from '../utility/encode-utils';
import { DesktopService } from './desktop.service';

@Injectable({ providedIn: 'root' })
export class DesktopUsbService {
  constructor(private _desktop: DesktopService) {}

  sendDataToDevice(
    deviceId: string,
    data: string | ArrayBuffer | number[] | Uint8Array,
    timeout = 30000
  ): Promise<void> {
    if (!deviceId) {
      return Promise.reject('Device id is required');
    }

    if (typeof data === 'string') {
      this._desktop.send({
        Method: 'usbSend',
        DeviceId: deviceId,
        Text: data,
        CodePage: 'windows1251',
        Timeout: timeout,
      });
    } else {
      this._desktop.send({
        Method: 'usbSend',
        DeviceId: deviceId,
        Data: this._toBase64(data),
        Timeout: timeout,
      });
    }

    return this._desktop
      .on('usbSend')
      .pipe(
        map(() => {
          return;
        })
      )
      .toPromise();
  }

  private _toBase64(data: ArrayBuffer | number[] | Uint8Array): string {
    if (data instanceof ArrayBuffer) {
      return EncodeUtils.arrayBufferToBase64(new Uint8Array(data));
    }

    if (Array.isArray(data)) {
      return EncodeUtils.arrayBufferToBase64(new Uint8Array(data));
    }

    return EncodeUtils.arrayBufferToBase64(data);
  }
}
